import {FC} from 'react'
import {WithChildren} from '../helpers'
import {useUserPreferencesStore, Lang} from '../../app/tfi/store/userPreferencesStore'

// The selected language is a user preference: it lives in `useUserPreferencesStore`
// (persisted to localStorage AND synced to the backend + hydrated on login), so it
// follows the user across devices. This module keeps the historical i18n API
// (`useLang` / `useSetLang`) as thin selectors over that single source of truth.

export type {Lang}

const useLang = (): Lang => useUserPreferencesStore((s) => s.language)

const useSetLang = (): ((lang: Lang) => void) =>
  useUserPreferencesStore((s) => s.setLanguage)

// Kept as a passthrough so the existing mount point in index.tsx stays untouched.
const MetronicI18nProvider: FC<WithChildren> = ({children}) => <>{children}</>

export {MetronicI18nProvider, useLang, useSetLang}
